import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';

import * as userDataActions from '../../../actions/userDataActions';
import * as appConstants from "../../../constants/appConstants";
import * as appHelper from '../../../helpers/appHelper';
import * as userDataHelper from '../../../helpers/userDataHelper';
import * as objectConstants from '../../../constants/objectConstants';
import {TweenLite, Elastic, Bounce, Expo} from 'gsap';
import gsap from 'gsap-react-plugin';

class ResourceDocumentLink extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            lang: this.props.lang,
            resource: this.props.resource,
            userData: this.props.userData,
            locale: appHelper.getLocalData(this.props.resource),
            document: {},
            required_label: appHelper.getLocaleString("required_label")
        };
        this.onOpen = this.onOpen.bind(this);
        this.getStatusClass = this.getStatusClass.bind(this);
        this.getAssets = this.getAssets.bind(this);
        this.getFilePath = this.getFilePath.bind(this);
        this.updateResourceObjectResult = this.updateResourceObjectResult.bind(this);
    }

    componentDidMount() {
        this.getAssets();
    }

    componentWillReceiveProps(nextProps) {
        if(this.state.userData !== nextProps.userData){
            this.setState({userData: Object.assign({}, nextProps.userData)});
        }

        if(this.state.lang !== nextProps.lang){
            let document = appHelper.getDocumentAsset(this.state.resource);
            this.setState({
                lang: nextProps.lang,
                locale: appHelper.getLocalData(this.state.resource),
                document: appHelper.isDefined(document.locale) ? appHelper.getLocalData(document) : document,
                required_label: appHelper.getLocaleString("required_label")
            });
        }
    }

    componentDidUpdate() {

    }

    getAssets() {
        let document = appHelper.getDocumentAsset(this.state.resource);
        this.setState({document: appHelper.isDefined(document.locale) ? appHelper.getLocalData(document) : document });

    }

    getFilePath(src) {
        if (appConstants.DEVELOPMENT_MODE) {
            if (appHelper.isDefined(src) && src.length > 0) {
                return require(`../../../../moveToDist/${src}`);
            }
        } else {
            return src;
        }
    }

    getStatusClass(){
        let objectUserData = userDataHelper.getAttachmentObjectUserData(this.state.userData, this.state.resource.asset_id);

        if (objectUserData.status === objectConstants.STATUS_NOT_STARTED) {
            return "not-started";
        } else if (objectUserData.status === objectConstants.STATUS_IN_PROGRESS) {
            return "in-progress";
        } else if (objectUserData.status === objectConstants.STATUS_COMPLETE) {
            return "complete";
        }
    }

    onOpen(){
        this.updateResourceObjectResult();
    }

    updateResourceObjectResult(){
        let params ={
            asset_id: this.state.resource.asset_id,
            asset_type_code: this.state.resource.object_type,
            status: objectConstants.STATUS_COMPLETE,
        };

        this.props.actions.updateResourceObjectResult(params).then((userData) => {
            this.props.actions.setSuspendData(userData).then((trackingData) => {}).catch(error => {});
        }).catch(error => {
        });
    }

    render() {
        return (
            <li className={`resource-link ${this.getStatusClass()}`}>
                <a className="document" onClick={this.onOpen} href={this.getFilePath(this.state.document.src)} target="_blank" dangerouslySetInnerHTML={{__html: this.state.locale.label}} />
                {this.state.resource.required
                    ?
                    <span className="required-label"> - {this.state.required_label}</span>
                    :
                    null
                }
            </li>
        );
    }
}

ResourceDocumentLink.propTypes = {
    resource: PropTypes.object.isRequired,
    trackingData: PropTypes.object.isRequired,
    userData: PropTypes.object.isRequired,
    lang: PropTypes.string.isRequired,
    actions: PropTypes.object.isRequired
};

ResourceDocumentLink.contextTypes = {
    router: PropTypes.object
};

function mapStateToProps(state, ownProps) {
    let lang = state.userData.lang;
    return {
        lang:lang,
        contentData: state.contentData,
        trackingData: state.trackingData,
        userData: state.userData
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, userDataActions), dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(ResourceDocumentLink);



/** WEBPACK FOOTER **
 ** ./src/components/objects/resourceLinks/ResourceDocumentLink.js
 **/